import { TSearchProps } from './Search';

import ReactSelect, { SingleValue } from 'react-select';

import SearchButton from '@/components/buttons/SearchButton';
import * as actions from '@/actions';

export const SearchDesktop = ({
  activityList,
  selectedActivity,
  handleSelectActivity,
  locationList,
  selectedLocation,
  handleSelectLocation,
}: TSearchProps) => {
  const experienceSlug =
    selectedActivity && selectedActivity.value !== 0 ? selectedActivity.slug ?? '' : '';
  const countrySlug =
    selectedLocation && selectedLocation.value !== 0 ? selectedLocation.slug ?? '' : '';

  return (
    <form
      action={actions.search}
      className="relative w-fit h-auto hidden lg:flex flex-row items-center text-md text-gray-400 bg-gray-800 py-1 pr-2 pl-8 rounded-full border border-transparent hover:border-gray-700"
    >
      <input type="hidden" name="experience" value={experienceSlug} readOnly />
      <input type="hidden" name="country" value={countrySlug} readOnly />
      <div className="w-[192px] h-12 flex items-center bg-transparent">
        <ReactSelect
          instanceId="location"
          name="location-display"
          placeholder="Anywhere"
          options={locationList}
          className="select-dropdown no-separator no-arrow text-white bg-gray-800"
          classNamePrefix="select-dropdown"
          classNames={{
            valueContainer: () => 'text-white rounded-lg',
            input: () => 'text-white',
          }}
          value={selectedLocation}
          isClearable={true}
          openMenuOnFocus={true}
          onChange={(location) => handleSelectLocation(location)}
        />
      </div>

      <div className="h-[20px] border-r border-gray-700"></div>

      <div className="w-[178px] h-12 flex items-center pl-4">
        <ReactSelect
          instanceId="activity"
          name="activity-display"
          placeholder="Activity"
          options={activityList}
          className="select-dropdown no-separator no-arrow text-white bg-gray-800"
          classNamePrefix="select-dropdown"
          classNames={{
            valueContainer: () => 'text-white rounded-lg',
            input: () => 'text-white',
          }}
          value={selectedActivity}
          isClearable={true}
          openMenuOnFocus={true}
          onChange={(activity) => handleSelectActivity(activity)}
        />
      </div>

      <SearchButton />
    </form>
  );
};
